import type { FederatedPointerEvent } from "pixi.js";
import type { CustomViewport } from "./CustomViewport";
import type { MapCoordinates } from "./MapCoordinates";
import type { Point2D } from "./types";

export interface MapPointerPosition {
    screenPosition: Point2D;
    worldPosition: Point2D;
}

export function getMapPointerPosition(
    event: FederatedPointerEvent,
    viewport: CustomViewport,
    coordinates: MapCoordinates,
): MapPointerPosition | null {
    if (!viewport.isUsable) return null;

    const screenPosition = {
        x: event.screen.x,
        y: event.screen.y,
    };
    const scenePosition = viewport.toWorld(screenPosition);

    return {
        screenPosition,
        worldPosition: coordinates.sceneToWorld(scenePosition),
    };
}
